// extracted by mini-css-extract-plugin
export default {"horLineStyle":"App_horLineStyle__OB54U","app":"App_app__zr1wm"};